import { shopPrefix } from '../../config';
import { http } from '../axios';
import { SubscriptionPeriod } from '../../../models/Article';

export type SubscriptionPeriodData = {
    currentSubscriptionPeriod: SubscriptionPeriod;
    nextSubscriptionPeriod: SubscriptionPeriod;
};

export const fetchSubscriptionPeriods = () => {
    return http.get<SubscriptionPeriodData>(`${shopPrefix}/v1/subscriptions/periods`).then(response => response.data);
};
